import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground-950 mb-3">
            平台特色
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            为什么千万读者选择新新漫画
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featuresData.map((item, i) => (
            <div
              key={i}
              className="group p-6 md:p-7 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 flex flex-col items-start gap-4"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl ${
                i === 0 ? 'bg-primary-100 text-primary-600' :
                i === 1 ? 'bg-accent-100 text-accent-700' :
                i === 2 ? 'bg-secondary-100 text-secondary-700' :
                'bg-primary-100/70 text-primary-600'
              }`}>
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>

              <h3 className="font-heading font-semibold text-lg md:text-xl text-foreground-900">
                {item.title}
              </h3>

              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}